import type { TGouvFeatureDto } from "@/api/gouv/search/gouv-address-search.type.ts";
import type { IAddressAdaptable, IAddressAdapter } from "@/domains/address/adapters/address-adapter.ts";
import type { IAddressVisitor, TAddressVisitorOutput } from "@/domains/address/address-visitor.ts";
import type { IExternalAddress } from "@/domains/address/external-address.ts";

import { cloneDeep } from "es-toolkit";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";

export class FrenchGovernmentAddress
  implements IExternalAddress<TGouvFeatureDto>, IAddressAdaptable<FrenchGovernmentAddress>
{
  constructor(private readonly rawFeature: TGouvFeatureDto) {
    this.rawFeature = cloneDeep(rawFeature);
  }

  accept<V extends IAddressVisitor>(visitor: V): TAddressVisitorOutput<V> {
    return visitor.visitGovernment(this) as TAddressVisitorOutput<V>;
  }

  adapt<OUTPUT>(adapter: IAddressAdapter<FrenchGovernmentAddress, OUTPUT>): OUTPUT {
    return adapter.adapt(this);
  }

  getProvider(): EAddressProvider {
    return EAddressProvider.FRENCH_GOVERNMENT;
  }

  getRaw(): TGouvFeatureDto {
    return this.rawFeature;
  }
}
